import React, {useRef, useState} from 'react';
import {Query} from "@syncfusion/ej2-data";
import {useTranslation} from "react-i18next";
import GridTab from "../../../../../ui/components/Grid/GridTab/GridTab";
import GridTabSection, {
    GridTabSectionType
} from "../../../../../ui/components/Grid/GridTab/GridTabSection/GridTabSection";
import GridTabItem from "../../../../../ui/components/Grid/GridTab/GridTabItem/GridTabItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import Loader from "../../../../../ui/components/Loader/Loader";
import GridComponent from "../../../../../ui/components/Grid/GridComponent";
import {ColumnDirective, ColumnsDirective, Filter, Inject, Page, Sort} from "@syncfusion/ej2-react-grids";
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import {DialogComponent} from '@syncfusion/ej2-react-popups';
import apiAxios from "../../../../../../app/api/apiAxios";
import axios from "axios";
import {decode} from "js-base64";

const EntrancesGrid = ({buildingId}) => {

    const [query] = useState(new Query().addParams('id', buildingId));
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const {t} = useTranslation();


    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedId, setSelectedId] = useState(0);

    const resetUploader = () => {
        setSelectedFile(null);
        setSelectedFileName('');
    };

    const openEditDialog = (row: any) => {


        setSelectedId(row.id)

        setIsDialogOpen(true);
        resetUploader()
    };

    const closeDialog = () => {
        if (saving) return;
        setIsDialogOpen(false);
        resetUploader()
    };

    const handleSave = async () => {
        try {
            setSaving(true);

            if (selectedFile) {
                const formData = new FormData();
                formData.append('file', selectedFile);
                formData.append('id', selectedId);

                const _apiAxios = axios.create({
                    baseURL: `${process.env.REACT_APP_BE_DOMAIN}`,
                })

                _apiAxios.interceptors.request.use((config) => {
                    if (localStorage.getItem('_d')) {
                        const parsedData = JSON.parse(decode(localStorage.getItem('_d')));
                        if (parsedData && (typeof parsedData === 'object')) {
                            config.headers["Authorization"] = `Bearer ${parsedData.token}`
                        }
                    }
                    return config;
                });


                const url = `${process.env.REACT_APP_BE_DOMAIN}/api/building/saveEntrance`;
                const uploadResponse = await _apiAxios.post(url,
                    formData);

                if (!uploadResponse || uploadResponse.status !== 200) {
                    throw new Error('Upload failed');
                }
            }
            setIsDialogOpen(false);
            resetUploader()
            setRefreshTrigger(prev => prev + 1);


        } catch (e) {
            console.error(e);
        } finally {
            setSaving(false);
        }
    };


    const onTabItemClick = ({id}) => {
        if (id) {
            if (id === 'refresh-btn') {
                setRefreshTrigger(prev => prev + 1);
            }
        }
    }
    const dialogButtons = [
        {
            buttonModel: {
                content: t('btn.save'),
                isPrimary: true,
            },
            click: handleSave,
        },
        {
            buttonModel: {
                content: t('btn.cancel'),
            },
            click: closeDialog,
        },
    ];
    return (
        <>
            <GridTab onClick={onTabItemClick}>
                <GridTabSection type={GridTabSectionType.Button}>
                    <GridTabItem id='refresh-btn'
                                 text={t("btn.refresh")}
                                 icon={<FontAwesomeIcon icon={faRefresh}/>}>

                    </GridTabItem>
                </GridTabSection>
            </GridTab>
            {
                !query
                    ? <Loader/>
                    : <GridComponent id='grid'
                                     container='.entrances-container'
                                     url='/api/building/getEntrances'
                                     query={query}
                                     heightMinus={2}
                                     refresh={refreshTrigger}
                                     allowFiltering={false}>
                        <ColumnsDirective>
                            <ColumnDirective field='id'
                                             visible={false}
                                             textAlign="center"
                                             isPrimaryKey={true}
                                             type='number'/>
                            <ColumnDirective field='number'
                                             headerText={t("user.form.entrances")}
                                             width='200'
                                             textAlign="left"/>
                            <ColumnDirective field='fileName'
                                             headerText={t("user.form.qr")}
                                             width='200'
                                             textAlign="left"/>
                            <ColumnDirective field='hasQR'
                                             headerText={t("user.form.qr")}
                                             template={(props: any) => (
                                                 <input
                                                     type="checkbox"
                                                     checked={props.hasQR}
                                                     disabled
                                                 />
                                             )}
                                             width="50"/>
                            <ColumnDirective
                                headerText='Actions'
                                width='100'
                                textAlign='center'
                                template={(props: any) => (
                                    <button
                                        type="button"
                                        className="e-btn e-primary"
                                        onClick={() => openEditDialog(props)}
                                    >
                                        Edit
                                    </button>
                                )}
                            />
                        </ColumnsDirective>
                        <Inject services={[Page, Sort, Filter]}/>
                    </GridComponent>
            }
            <DialogComponent
                visible={isDialogOpen}
                header={t('btn.edit')}
                width="500px"
                isModal={true}
                showCloseIcon={true}
                close={closeDialog}
                buttons={dialogButtons}
            >
                <div style={{display: 'grid', gap: 16}}>


                    <div>

                        {isDialogOpen && <UploaderComponent
                            multiple={false}
                            autoUpload={false}
                            showFileList={true}
                            allowedExtensions=".png"
                            buttons={{
                                browse: 'Select file',
                                upload: '',
                                clear: ''
                            }}
                            selected={(args: any) => {
                                setSelectedFile(args.filesData?.[0]?.rawFile || null);
                                setSelectedFileName( args.filesData?.[0]?.name || null)
                            }}
                            removing={() => {
                                setSelectedFile(null);
                                setSelectedFileName('')
                            }}
                        />}
                    </div>


                </div>
            </DialogComponent>
        </>
    );
};

export default EntrancesGrid;
